<template>
	<div class="sf-widget-body widget-progress">
		<sf-data-table :columns="columns" :rows="rows" :rowClassName="getRowClass" :stripe="false" />
	</div>
</template>

<script>
import { serviceComputed, serviceMethods } from './store/helpers';
import client from '@/api/client';
import { emitSyncDate } from '@common/WidgetComponent/common';
import { BASE_URL } from '@/constants';

const api = {
	selectProgress: ({ plantCd, shopCd }) =>
		client.get(`${BASE_URL}/customizingBoard/v1/plants/${plantCd}/shops/${shopCd}`).then(res => res && res.data)
};

export default {
	name: 'widget-progress',
	props: ['para'],
	created() {
		this.refresh();
	},
	computed: {
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		getRowClass({ row: { SUM_FLG: sumFlg }, rowIndex }) {
			return (
				{
					1: 'row-sum',
					2: 'row-sum total'
				}[sumFlg] || ''
			);
		},
		refresh() {
			const plantCd = _.get(this, 'para.settings.plantCd');
			const shopCd = _.get(this, 'para.settings.shopCd');
			if (!plantCd || !shopCd) {
				return Promise.resolve(null);
			}
			return api
				.selectProgress({ plantCd, shopCd })
				.then(res => {
					const { productionTotalList, stnList } = res.body;
					this.columns = [{ label: '항목', prop: 'INQ_ITEM_NM', minWidth: 150 }].concat(
						stnList.sort(r => r.code).map(r => ({ label: r.codeName, prop: r.codeName }))
					);
					this.rows = productionTotalList.sort(r => r.INQ_SEQ);
					emitSyncDate(this);
				})
				.catch(e => {
					// console.error(`failed to load CustomizingBoard data (${plantCd} / ${shopCd})`);
				});
		}
	},
	watch: {
		para() {
			this.refresh();
		}
	},
	data() {
		return {
			columns: [
				{
					label: '항목',
					prop: 'INQ_ITEM_NM',
					minWidth: 130,
					className: 'first-column'
				},
				{
					label: '차체IN',
					prop: '차체IN'
				},
				{
					label: '도장IN',
					prop: '도장IN'
				},
				{
					label: '상도IN',
					prop: '상도IN'
				}
			],
			rows: [
				{
					트림1: '999',
					차체IN: '999',
					도장IN: '999',
					INQ_ITEM_NM: 'LF 내수',
					SUM_FLG: '999',
					'PBS/O': '999',
					상도IN: '999',
					통제소: '999',
					ITEM_SEQ: '999',
					'S/OFF': '999',
					OK: '999',
					'PBS/I': '999',
					INQ_SEQ: '999'
				},
				{
					트림1: '999',
					차체IN: '999',
					도장IN: '999',
					INQ_ITEM_NM: 'DN8 내수',
					SUM_FLG: '999',
					'PBS/O': '999',
					상도IN: '999',
					통제소: '999',
					ITEM_SEQ: '999',
					'S/OFF': '999',
					OK: '999',
					'PBS/I': '999',
					INQ_SEQ: '999'
				},
				{
					트림1: '999',
					차체IN: '999',
					도장IN: '999',
					INQ_ITEM_NM: 'DN8 수출',
					'PBS/O': '999',
					상도IN: '999',
					통제소: '999',
					INQ_SEQ: '999',
					PDI: '999',
					SUM_FLG: '999',
					ITEM_SEQ: '999',
					'S/OFF': '999',
					OK: '999',
					'PBS/I': '999'
				},
				{
					트림1: '999',
					차체IN: '999',
					도장IN: '999',
					INQ_ITEM_NM: 'DN8 합계',
					'PBS/O': '999',
					상도IN: '999',
					통제소: '999',
					INQ_SEQ: '999',
					PDI: '999',
					SUM_FLG: '1',
					ITEM_SEQ: '999',
					'S/OFF': '999',
					OK: '999',
					'PBS/I': '999'
				},
				{
					트림1: '999',
					차체IN: '999',
					도장IN: '999',
					INQ_ITEM_NM: 'DN8-HEV 내수',
					SUM_FLG: '999',
					'PBS/O': '999',
					통제소: '999',
					ITEM_SEQ: '999',
					'S/OFF': '999',
					OK: '999',
					INQ_SEQ: '999'
				},
				{
					트림1: '999',
					차체IN: '999',
					도장IN: '999',
					INQ_ITEM_NM: 'DN8-HEV 수출',
					'PBS/O': '999',
					상도IN: '999',
					통제소: '999',
					INQ_SEQ: '999',
					PDI: '999',
					SUM_FLG: '999',
					ITEM_SEQ: '999',
					'S/OFF': '999',
					OK: '999',
					'PBS/I': '999'
				}
			]
		};
	}
};
</script>

<style></style>
